import { ajaxSend } from '../../../api/api';
const basePath = '/v1/messaging/apps';
export function getAppList() {
    return ajaxSend({
        path: basePath,
    });
}
export function getIntegrations({ appId }) {
    return ajaxSend({
        path: `${basePath}/${appId}/integrations`,
    });
}
export function signup(payload) {
    return ajaxSend({
        path: '/v1/messaging/whatsapp/signup',
        method: 'POST',
        data: payload,
    });
}
export function updateIntegration({ appId, integrationId, payload }) {
    return ajaxSend({
        path: `${basePath}/${appId}/integrations/${integrationId}`,
        method: 'PUT',
        data: payload,
    });
}
export function deleteIntegration({ integrationId }) {
    console.warn('Delete integration (TODO)', integrationId);
}
